import { graphql } from 'gatsby';
import React from 'react';
import BlogsComponent from '../components/blog/gallery';
import Layout from '../components/layout';
import SEO from '../components/seo';

export const pageQuery = graphql`
  query BlogsQuery {
    allContentfulBlogs {
      edges {
        node {
          id
          blogUrl
          slug
          title
          blogImg {
            url
          }
          created
          readTime
          author
          profileIMG {
            url
          }
          categoryName
          categoryType
          summary
        }
      }
    }
    contentfulStaticPages(slug: { eq: "blogs" }) {
      id
      title
      slug
      featureImage {
        url
        description
      }
      description
    }
  }
`;

export default function Blogs({ data, location }) {
  const blogData = data.allContentfulBlogs.edges.map(({ node }) => node);
  const metaData = data.contentfulStaticPages;
  return (
    <Layout location={location}>
      <SEO
        title={metaData.title}
        description={metaData.description}
        image={metaData.featureImage.url}
        pathname="blogs"
        blogURL="blogs"
      />
      <BlogsComponent blogData={blogData} />
    </Layout>
  );
}
